<template>
  <div>
    <Header></Header>
    <Nav></Nav>
    <div class="invoice">
      <div class="invoice-one">
        <div class="invoiceFrom">
          <el-form :model="invoice"
                   :rules="rules"
                   ref="invoice"
                   size="mini"
                   label-width="100px"
                   class="demo-ruleForm"
                   label-position="top">
            <el-form-item label="发票类型:"
                          prop="invoice_type">
              <el-select placeholder="请选择发票类型"
                         @change="other"
                         v-model="invoice.invoice_type">
                <el-option v-for="item in invoice_addlist"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value+''">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票抬头:"
                          prop="header">
              <el-input size="small"
                        v-model="invoice.header"
                        placeholder="请输入发票抬头"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别码:"
                          prop="taxpayer">
              <el-input size="small"
                        v-model="invoice.taxpayer"
                        placeholder="请输入纳税人识别码"></el-input>
            </el-form-item>
            <div v-if="otherInfo==2">
              <el-form-item label="开户行:"
                            prop="bank_num">
                <el-input size="small"
                          v-model="invoice.bank_num"
                          placeholder="请输入开户行"></el-input>
              </el-form-item>
              <el-form-item label="银行账号:"
                            prop="bank_account">
                <el-input size="small"
                          v-model="invoice.bank_account"
                          placeholder="请输入银行账号"></el-input>
              </el-form-item>
              <el-form-item label="注册地址:"
                            prop="register_address">
                <el-input size="small"
                          v-model="invoice.register_address"
                          placeholder="请输入注册地址"></el-input>
              </el-form-item>
              <el-form-item label="注册电话:"
                            prop="register_tel">
                <el-input size="small"
                          v-model="invoice.register_tel"
                          placeholder="请输入注册电话"></el-input>
              </el-form-item>
            </div>

            <el-form-item>
              <div class="flex">
                <div class="sub"
                     @click="saveInvoice('invoice')">保存发票信息</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/purchase/header/header'
import Nav from '@/components/purchase/nav/nav'
import Footer from '@/components/purchase/footer/footer'
import './invoiceInformation.css'
export default {
  components: {
    Header,
    Nav,
    Footer
  },
  data() {
    return {
      invoice: {
        invoice_type: '',
        header: '',
        taxpayer: '',
        bank_num: '',
        bank_account: '',
        register_address: '',
        register_tel: ''
      },
      otherInfo: '', //显示隐藏专票信息
      invoice_addlist: [
        {
          value: 1,
          label: '增值税普通发票'
        },
        {
          value: 2,
          label: '增值税专用发票'
        }
      ],
      rules: {
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' }
        ],
        header: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        taxpayer: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' }
        ],
        bank_num: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        register_address: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        register_tel: [
          { required: true, message: '请输入注册电话', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.myInfo()
  },
  mounted() {},
  methods: {
    // 初次回显发票信息
    myInfo() {
      this.$api
        .invioceInfo({
          shop_type: 'qycg',
          access_token: this.$store.state.qycg_user.access_token
        })
        .then(res => {
          // console.log(res)
          if (res.code == 0) {
            this.invoice = res.data
            // this.invoice.invoice_type = res.data.invoice_type + ''
            // console.log(this.invoice.invoice_type)
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'warning',
              offset: 200,
              duration: 1000
            })
          }
        })
        .catch(err => {
          // console.log(err);
        })
    },
    // 保存发票信息
    saveInvoice(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api
            .addInvioce({
              shop_type: 'qycg',
              // access_token: this.$store.state.qycg_user.access_token,
              invoice_type: this.invoice.invoice_type,
              header: this.invoice.header,
              taxpayer: this.invoice.taxpayer,
              bank_account: this.invoice.bank_account,
              bank_num: this.invoice.bank_num,
              register_address: this.invoice.register_address,
              register_tel: this.invoice.register_tel
            })
            .then(res => {
              // console.log(res)
              if (res.code == 0) {
                this.$message({
                  showClose: true,
                  message: '添加成功',
                  type: 'success',
                  offset: 200,
                  duration: 1000
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'warning',
                  offset: 200,
                  duration: 1000
                })
              }
            })
            .catch(err => {
              // console.log(err);
            })
        }
      })
    },
    // 显示隐藏不同发票填写的内容
    other(val) {
      if (val == 1) {
        this.otherInfo = 1
      } else {
        this.otherInfo = 2
      }
      // console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.invoice {
  width: 100%;
  background-color: #f2f2f2;
  padding-top: 20px;
  .invoice-one {
    width: 1080px;
    height: 763px;
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    .invoiceFrom {
      width: 100%;
      padding: 24px 20px 24px 450px;
      box-sizing: border-box;
      margin: 0 auto;

      .flex {
        display: flex;
      }
      .sub {
        cursor: pointer;
        width: 114px;
        height: 32px;
        background: #ff0e25;
        border-radius: 2px;
        color: #fff;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
      }
    }
  }
}
</style>